const styles = {
  Platform_container: {
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F7F9FC",
    scrollMarginTop: "80px",
    padding: {
      xs: "48px 20px 56px",
      sm: "64px 20px 72px",
      md: "80px 20px 96px",
    },
  },
  Platform_textContainer: {
    width: "100%",
    maxWidth: "980px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  Platform_grid: {
    width: "100%",
    maxWidth: "none",
    minWidth: 0,
    boxSizing: "border-box",
    display: "grid",
    gridTemplateColumns: {
      xs: "minmax(0, 1fr)",
      sm: "repeat(2, minmax(0, 1fr))",
      lg: "repeat(3, minmax(0, 1fr))",
    },
    gap: { xs: 1.5, md: 2 },
    mt: { xs: 3, sm: 4, md: 4.5 },
    px: { xs: 1, sm: 3, md: 5 },
    "@media (max-width:600px) and (max-height:750px)": {
      px: 0,
    },
  },
  Platform_card: {
    width: "100%",
    minWidth: 0,
    minHeight: { xs: "180px", sm: "195px" },
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    border: "1px solid #D7E1EF",
    borderTop: "6px solid #3F67A5",
    borderRadius: "8px",
    boxShadow: "0 12px 28px rgba(34, 49, 78, 0.05)",
    padding: { xs: "14px", sm: "16px" },
    textAlign: "start",
    overflow: "hidden",
  },
  Platform_iconContainer: {
    width: "42px",
    height: "42px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    backgroundColor: "#EAF1FA",
    borderRadius: "8px",
    mb: 1.5,
  },
  Platform_icon: {
    color: "#3F67A5",
    fontSize: "22px",
  },
  Platform_cardTitle: {
    color: "#22314E",
    fontSize: { xs: "1.1rem", sm: "1.2rem" },
    fontWeight: 800,
    letterSpacing: 0,
    lineHeight: 1.25,
    mb: 0.75,
    overflowWrap: "anywhere",
  },
  Platform_cardDescription: {
    color: "#58687D",
    fontSize: { xs: "0.9rem", sm: "0.95rem" },
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: 1.5,
    overflowWrap: "anywhere",
  },
};

export default styles;
